/**
 * Index of the index cell (for row numbering and row selection).
 * Constant is used to mark index cell references as such and to avoid magic numbers.
 *
 * @type {number}
 */
export const INDEX_COLUMN_INDEX = 0;
